module.exports = __webpack_public_path__ + "static/media/todo-complete.10a5b071.svg";